import { createFieldSelectorHook } from 'src/lib/sweetState';

import { CustomerStore } from './CustomerStore';

export const useCurrentCustomers = createFieldSelectorHook(CustomerStore, 'currentCustomers');
